import React, { useState } from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom';
import { showsLiveTracking, getExpectedDeliveryDate, formatDeliveryDate, buildDelaySnapshot, SNAPSHOT_ON_STATUS, getSavedDelayInfo, wasOrderDelayed } from './orderStatus';

const OrderRow = ({ order, i, delayed }) => {
    // "Ship by ..." note and the live delayed badge both show for NEW only.
    const shipBy = showsLiveTracking(order)
        ? formatDeliveryDate(getExpectedDeliveryDate(order))
        : ""

    // Recorded when the order was confirmed. Shown for every status except NEW,
    // where the delay is still worked out live instead.
    const showSavedDelay = wasOrderDelayed(order)
    const savedDelay = getSavedDelayInfo(order)
    const daysLate = Number(savedDelay?.daysLate)
    const [invoiceLoading, setInvoiceLoading] = useState(false)
    const [labelLoading, setLabelLoading] = useState(false)

    const currentStatus = order.attributes.status
    const [newStatus, setNewStatus] = useState(currentStatus)
    const [statusLoading, setStatusLoading] = useState(false)
    const [accountLoading, setAccountLoading] = useState(false)
    const [salesAccount, setSalesAccount] = useState(order.attributes.salesAccount || null);
    const options = [
        {
            label: "Maintive Networks ECM",
            value: { accountCode: "MAI021", accountName: "MAINTIVE" }
        },
        {
            label: "Maintive Delivery COD-DC",
            value: { accountCode: "MAI032", accountName: "MAINTIVE CASH ON DELIVERY" }
        },
        {
            label: "Maintive Amazon PG",
            value: { accountCode: "MAI034", accountName: "MAINTIVE AMAZON PAYMENT GATEWAY" }
        },
        {
            label: "Maintive Payment At DC",
            value: { accountCode: "MAI037", accountName: "MAINTIVE PAYMENT AT COUNTER" }
        },
        {
            label: "Maintive Courier COD",
            value: { accountCode: "MAI039", accountName: "MAINTIVE COURIER COD" }
        }
    ];
    const handleChange = (e) => {
        const selectedValue = JSON.parse(e.target.value); // convert string → object
        console.log("{...selectedValue,label:e.target.label}", { ...selectedValue, label: e.target.label })
        setSalesAccount({ ...selectedValue, label: e.target.label });
    };

    const downloadInvoice = (order) => {
        setInvoiceLoading(true)
        const formattedOrder = { ...order.attributes, id: order.id }
        axios.post("/api/orders/invoice", {
            data: formattedOrder
        }, {
            responseType: 'blob',
            headers: {
                "x-auth-token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7ImlkIjoiNWUwMzE1MDQyMmFhNGIwMDI4MTJjZDdmIn0sImlhdCI6MTY2NDk3NjUxOX0.wlsQHICTcv17qta-W_3oRSfhbkOmIsrlZ6DS-7ZvyQk",
                "api-key": "de1fbd60-b095-40fc-a040-af58528a9164",
                "secret-key": "4b8c1f3b-ce31-4ea5-8395-a02fed773ab0"
            }
        })
            .then(res => {
                console.log("success")
                const invoice = new Blob(
                    [res.data],
                    { type: 'application/pdf' });

                //Build a URL from the file
                const fileURL = URL.createObjectURL(invoice);
                setInvoiceLoading(false)
                //Open the URL on new Window
                window.open(fileURL);
            }).catch(err => {
                console.error(err)
                setInvoiceLoading(false)
            })
    }

    const handleStatusChange = () => {
        setStatusLoading(true)

        // Freeze the delay before the status moves off pending, otherwise it
        // can no longer be worked out. Null for every other transition.
        const delayInfo = newStatus === SNAPSHOT_ON_STATUS
            ? buildDelaySnapshot(order)
            : null



        axios.post("/api/orders/update-status", {
            data: {
                orderID: order.attributes.orderID,
                status: order.attributes.status,
                newStatus: newStatus,
                ...(delayInfo ? { delayInfo } : {})
            }
        }, {
            headers: {
                "x-auth-token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7ImlkIjoiNWUwMzE1MDQyMmFhNGIwMDI4MTJjZDdmIn0sImlhdCI6MTY2NDk3NjUxOX0.wlsQHICTcv17qta-W_3oRSfhbkOmIsrlZ6DS-7ZvyQk",
                "api-key": "de1fbd60-b095-40fc-a040-af58528a9164",
                "secret-key": "4b8c1f3b-ce31-4ea5-8395-a02fed773ab0"
            }
        }).then(res => {
            window.location = "/orders"
        }).catch(error => {
            console.log(error)
            setStatusLoading(false)
        })
    }
    const handleAccountUpdate = () => {
        setAccountLoading(true)
        axios.post("/api/orders/update-sales-account", {
            data: {
                orderID: order.attributes.orderID,
                salesAccount: salesAccount

            }
        }, {
            headers: {
                "x-auth-token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7ImlkIjoiNWUwMzE1MDQyMmFhNGIwMDI4MTJjZDdmIn0sImlhdCI6MTY2NDk3NjUxOX0.wlsQHICTcv17qta-W_3oRSfhbkOmIsrlZ6DS-7ZvyQk",
                "api-key": "de1fbd60-b095-40fc-a040-af58528a9164",
                "secret-key": "4b8c1f3b-ce31-4ea5-8395-a02fed773ab0"
            }
        }).then(({ data }) => {
            alert("sales account details updated!")
            window.location = "/orders"
            setAccountLoading(false)
        }).catch(error => {
            console.log(error)
            setAccountLoading(false)
        })
    }
    const downloadLabel = (orderID) => {
        setLabelLoading(true)
        axios.post("/api/shipping/skyex/create-label", {
            data: {
                'orderID': orderID
            }
        }, {
            responseType: 'blob',
            headers: {
                "x-auth-token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7ImlkIjoiNWUwMzE1MDQyMmFhNGIwMDI4MTJjZDdmIn0sImlhdCI6MTY2NDk3NjUxOX0.wlsQHICTcv17qta-W_3oRSfhbkOmIsrlZ6DS-7ZvyQk",
                "api-key": "de1fbd60-b095-40fc-a040-af58528a9164",
                "secret-key": "4b8c1f3b-ce31-4ea5-8395-a02fed773ab0"
            }
        })
            .then(res => {
                console.log("success")
                const invoice = new Blob(
                    [res.data],
                    { type: 'application/pdf' });

                //Build a URL from the file
                const fileURL = URL.createObjectURL(invoice);
                setLabelLoading(false)
                //Open the URL on new Window
                window.open(fileURL);
            }).catch(err => {
                setLabelLoading(false)
                console.error(err)
            })
    }
    return (
        <tr key={i} className={
            'border border-black  '
            + (i % 2 == 0 ? 'bg-slate-100 ' : '')
            + (order.attributes.status === "NEW" ? 'text-blue-600 ' : '')
        }
        >
            <td className='px-3 flex flex-col gap-2 text-left w-56 '>
                {delayed &&
                    <span className="animate-pulse bg-red-600 text-white font-bold text-center rounded px-2 py-1 shadow-md ring-2 ring-red-300">
                        ⚠ Delayed Order
                    </span>
                }
                {shipBy &&
                    <span className="bg-amber-100 text-amber-900 border border-amber-400 rounded px-2 py-1 text-xs font-medium">
                         Ship by {shipBy} before 4 pm
                    </span>
                }
                {showSavedDelay &&
                    <span
                        title={savedDelay.expectedDeliveryDate ? "Expected by " + savedDelay.expectedDeliveryDate : ""}
                        className="bg-red-600 text-white rounded  py-1 text-xs font-semibold text-center"
                    >
                        Delayed
                        {/* {Number.isFinite(daysLate) && daysLate > 0
                            ? ` by ${daysLate} day${daysLate > 1 ? "s" : ""}`
                            : ""} */}
                    </span>
                }
                {order.attributes.status === "NEW" && <span className="bg-blue-700 rounded text-white w-12 text-center">NEW </span>}
                {order.attributes.orderID}
                <p> {order.attributes.customerEmail} </p>
                <Link className="border text-center my-2 rounded bg-primary text-white hover:bg-primary-accent py-1" to={"/orders/" + order.attributes.orderID}>View Details</Link>
            </td>
            {/* <td>{order.attributes.customerEmail}</td> */}
            <td>
                <ul className=''>
                    {order.attributes.items.map((item, i) => (
                        <li key={i}>
                            {item.product.brand} {item.product.model} {item.calibration ? <span className='font-semibold'>+ CAL</span> : ""}</li>
                    ))}
                </ul>
            </td>
            <td>
                <ul>
                    {order.attributes.items.map((item, i) => (
                        <li key={i}>{item.qty}</li>
                    ))}
                </ul>
            </td>
            <td>
                <ul>
                    {order.attributes.items.map((item, i) => (
                        <li key={i}>AED {(item.price * item.qty).toFixed(2)} {item.calibration ? "(Cal: AED " + item.product.calibrationPrice + ")" : null}</li>
                    ))}
                </ul>
            </td>
            <td>
                
                <ul className='flex flex-col gap-1 py-2'>
                    {/* <li>Sub Total: AED {order.attributes.subTotal} {(order.attributes.customerCountry !== "United Arab Emirates" && order.attributes.customerCountry !== "الإمارات العربية المتحدة") ? <span className='text-red-500'>(5% vat removed)</span> : null}</li> */}
                    <li>Sub Total: AED {parseFloat(order.attributes.subTotal?.toFixed(2))} {(order.attributes?.shippingDetails?.countryId !== "AE") ? <span className='text-red-500'>(5% vat removed)</span> : null}</li>
                    <li>Shipping: AED {order.attributes.shipping}</li>
                    <li>Total: AED {order.attributes.total}</li>
                    {order.attributes.paymentMode === "ONLINE" &&
                        <li>Network Status: {order.attributes.paymentStatus}</li>}
                    {order.attributes.paymentStatus === "AUTHORISED" &&
                        <li>
                            <button className=' rounded-md bg-blue-700 text-white px-4 py-1'>Capture</button>
                        </li>
                    }
                </ul>

            </td>


            <td className="px-4 py-3 align-top">
                {/* Payment Method */}
                <div className="mb-3">
                    <span className="font-medium text-gray-700">Payment:</span>{" "}
                    <span
                        className={`px-2 py-1 text-sm rounded-md ${order.attributes.paymentMode === "COD"
                                ? "bg-yellow-100 text-yellow-800"
                                : order.attributes.paymentDetails?.payment_method === "AMAZON"
                                    ? "bg-purple-100 text-purple-800"
                                    : "bg-blue-100 text-blue-800"
                            }`}
                    >
                        {order.attributes.paymentMode === "COD"
                            ? "COD"
                            : order.attributes.paymentDetails?.payment_method === "AMAZON"
                                ? "AMAZON"
                                : "NETWORK"}
                    </span>
                </div>

                {/* Status Handling */}
                <div className="mb-4">
                    <label className="block mb-1 text-sm font-medium text-gray-700">
                        Status
                    </label>
                    <div className="flex items-center gap-2">
                        <select
                            value={newStatus}
                            onChange={(e) => setNewStatus(e.target.value)}
                            name="selectNewStatus"
                            className="w-full max-w-xs px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white text-gray-700"
                        >
                            <option value="NEW">NEW</option>
                            <option value="PAYMENTPENDING">PAYMENT_PENDING</option>
                            <option value="CONFIRMED">Confirmed</option>
                            <option value="SHIPPED">Shipped</option>
                            <option value="OUT_FOR_DELIVERY">Out for Delivery</option>
                            <option value="RETURNED_TO_ORIGIN">Returned to Origin</option>
                            <option value="EXCEPTION">Exception</option>
                            <option value="DELIVERED">Delivered</option>
                            <option value="RETURNED">Returned</option>
                            <option value="CANCELLED">Cancelled</option>
                        </select>
                        <button
                            disabled={currentStatus === newStatus || statusLoading}
                            title={order.attributes.orderID + " Save changes"}
                            onClick={handleStatusChange}
                            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg shadow hover:bg-blue-700 disabled:bg-gray-200 disabled:text-gray-400 transition"
                        >
                            Save
                        </button>
                    </div>
                </div>

                {/* Sales Account Selection */}
                <div className="w-full max-w-xs">
                    <label className="block mb-1 text-sm font-medium text-gray-700">
                        Sales Account
                    </label>
                    {!order?.attributes?.salesAccount?.accountCode?<select
                        onChange={handleChange}
                        value={salesAccount ? JSON.stringify(salesAccount) : ""}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white text-gray-700 hover:border-gray-400 transition"
                    >
                        <option value="" disabled>
                            Select Account
                        </option>
                        {options.map((opt, idx) => (
                            <option key={idx} value={JSON.stringify(opt.value)}>
                                {opt.label}
                            </option>
                        ))}
                    </select>
                    :
                    <div>
                        <span>Acount Code : {order?.attributes?.salesAccount?.accountCode}</span>
                    </div>
                    }

                    {order?.attributes?.salesAccount?.accountCode !==
                        salesAccount?.accountCode && (
                            <div className="mt-2">
                                <button
                                    disabled={
                                        order?.salesAccount?.accountCode === salesAccount?.accountCode ||
                                        accountLoading
                                    }
                                    title={order.attributes.orderID + " Save changes"}
                                    onClick={handleAccountUpdate}
                                    className="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-lg shadow hover:bg-green-700 disabled:bg-gray-200 disabled:text-gray-400 transition"
                                >
                                    Update
                                </button>
                            </div>
                        )}
                </div>
            </td>




            {/* <td>
                <select
                    value={newStatus}
                    onChange={e => setNewStatus(e.target.value)}
                    name="selectNewStatus"
                    className='border border-black px- py-1 rounded-sm'
                >
                    <option value="NEW">NEW</option>
                    <option value="PAYMENTPENDING">PAYMENT_PENDING</option>
                    <option value="CONFIRMED">Confirmed</option>
                    <option value="SHIPPED">Shipped</option>
                    <option value="OUT_FOR_DELIVERY">OUT_FOR_DELIVERY</option>
                    <option value="RETURNED_TO_ORIGIN">RETURNED_TO_ORIGIN</option>
                    <option value="EXCEPTION">EXCEPTION</option>
                    <option value="DELIVERED">Delivered</option>
                    <option value="RETURNED">RETURNED</option>
                    <option value="OUT_FOR_DELIVERY">Out for delivery</option>
                    <option value="CANCELLED">CANCELLED</option>
                </select>

            </td> */}
            <td className="w-full flex flex-col gap-2 my-2">
                {invoiceLoading ?
                    <span>Loading</span>
                    :
                    <button onClick={() => downloadInvoice(order)} title={order.attributes.orderID + " Invoice"} className="inline-block border rounded border-black bg-white p-1">Download Invoice</button>
                }
                {labelLoading ?
                    <span>Loading</span>
                    :
                    <button onClick={() => downloadLabel(order.attributes.orderID)} title={order.attributes.orderID + " Label"} className="inline-block border rounded border-black bg-white p-1">Download label</button>
                }
                {/* <button 
                    disabled={currentStatus === newStatus || statusLoading}
                    title={order.attributes.orderID + " Save changes"} 
                    onClick={handleStatusChange}
                    className="disabled:bg-gray-200 disabled:text-gray-400 inline-block border rounded bg-blue-500 text-white p-1"
                >
                    Save Changes
                </button> */}
            </td>
        </tr>
    )
}

export default OrderRow